<template>
  <v-tooltip top>
    <template slot="activator">
      <v-btn
        icon
        @click="$emit('click')">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'EmployeeTimesheetEditorQuickAction',
  props: ['icon', 'tooltip']
}
</script>

<style scoped>

</style>
